import { render } from "./SmModalCreateComponent.vue?vue&type=template&id=1af8e23a"
import script from "./SmModalCreateComponent.vue?vue&type=script&lang=js"
export * from "./SmModalCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmModalCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1af8e23a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1af8e23a', __exports__)) {
    api.reload('1af8e23a', __exports__)
  }
  
  module.hot.accept("./SmModalCreateComponent.vue?vue&type=template&id=1af8e23a", () => {
    api.rerender('1af8e23a', render)
  })

}


export default __exports__